























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardRiwayatPerkawinanRalan from "./CardRiwayatPerkawinanRalan.vue";
import Store from "@/store/modules/RiwayatPerkawinanRalanStore";

@Component({
  components: { CardRiwayatPerkawinanRalan }
})
export default class RiwayatPerkawinanRalanPage extends Vue {
  @Prop() register!: number;
  @Prop() rm!: number;
  @Prop({ default: false }) isActive!: boolean;

  get loading() { return Store.loading; }
  get stateData() { return Store.data; }

  @Watch("isActive")
  onActiveChange(val: boolean) {
    if (val && !this.stateData) {
      this.getByRegister();
    }
  }

  @Watch("register")
  onRegisterChange() {
    Store.reset();
    this.getByRegister();
  }

  mounted() {
    if (this.isActive) {
      this.getByRegister();
    } else {
      // Pre-load supaya tab langsung punya data saat dibuka
      this.getByRegister();
    }
  }

  async getByRegister() {
    if (!this.register) return;
    await Store.getByRegister(this.register);
  }
}
